'use strict'

module.exports = function spin (spinstr, spun) {
  return spinstr[spun % spinstr.length]
}



//////////////////
// WEBPACK FOOTER
// ./~/fsevents/~/gauge/spin.js
// module id = 2871
// module chunks = 0